import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { usePortersContext } from '../contexts/usePortersContext';

export const useCurrentPorter = () => {
  const { user } = useAuthenticationContext();
  const { porters } = usePortersContext();
  return porters.find((p) => p.id === user?.porter?.id);
};
